// Map grids used by the tile catalogue and coordinate readouts (spec §9.2, §26). Registered with OpenLayers
// once at start-up.
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';

proj4.defs(
  'EPSG:27700',
  '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy ' +
    '+towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs',
);
proj4.defs(
  'EPSG:29901',
  '+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1 +x_0=200000 +y_0=250000 +ellps=airy ' +
    '+towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs',
);
proj4.defs(
  'EPSG:21781',
  '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 ' +
    '+ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs',
);
register(proj4);

const letters = 'ABCDEFGHJKLMNOPQRSTUVWXYZ'; // the OS grid skips I

/**
 * OS grid reference for a WGS84 position, e.g. "NN 25116 02708" (10-figure). Undefined outside the
 * British National Grid's 700 × 1300 km area.
 */
export function toOsGridRef(lon: number, lat: number): string | undefined {
  const [e, n] = proj4('EPSG:4326', 'EPSG:27700', [lon, lat]) as [number, number];
  if (e < 0 || n < 0 || e >= 700000 || n >= 1300000) return undefined;
  const e100k = Math.floor(e / 100000);
  const n100k = Math.floor(n / 100000);
  let l1 = 19 - n100k - ((19 - n100k) % 5) + Math.floor((e100k + 10) / 5);
  let l2 = (((19 - n100k) * 5) % 25) + (e100k % 5);
  l1 = Math.max(0, Math.min(24, l1));
  l2 = Math.max(0, Math.min(24, l2));
  const pad = (v: number) => String(Math.floor(v % 100000)).padStart(5, '0');
  return `${letters[l1]}${letters[l2]} ${pad(e)} ${pad(n)}`;
}
